module.exports = {
  VIEW: 'REWARDS_VIEW',
  MANAGE_SETTINGS: 'REWARDS_MANAGE_SETTINGS',
  MEMBERSHIP_UPGRADE: 'REWARDS_MEMBERSHIP_UPGRADE',
  GIFT_CREATE: 'REWARDS_GIFT_CREATE',
  REWARDS_REMOVE: 'REWARDS_REMOVE',
  ANALYTICS: 'REWARDS_ANALYTICS'
}
